// extracted by mini-css-extract-plugin
export default {"container":"deletemodal_container__RDyMn","closeButton":"deletemodal_closeButton__E3QdU","title":"deletemodal_title__xp2NK"};